import React, { useState } from 'react';
import { Card, Table, Tag, Button, Modal, Descriptions, Space, Badge } from 'antd';
import { InfoCircleOutlined, SyncOutlined } from '@ant-design/icons';

const AlgorithmLibraryModule = () => {
  const [loading, setLoading] = useState(false);
  const [selectedAlgo, setSelectedAlgo] = useState(null);

  const algorithms = [
    { key: '1', name: '随机森林回归', category: '机器学习', accuracy: '92%', status: 'active', author: '张伟', version: 'v2.3' },
    { key: '2', name: '植被指数线性回归', category: '统计模型', accuracy: '76%', status: 'deprecated', author: '李娜', version: 'v1.0' },
    { key: '3', name: '深度神经网络(DNN)', category: '深度学习', accuracy: '95%', status: 'active', author: '王强', version: 'v3.1' },
  ];

  const columns = [
    { title: '算法名称', dataIndex: 'name', render: t => <b>{t}</b> },
    { title: '类别', dataIndex: 'category', render: t => <Tag color="blue">{t}</Tag> },
    { title: '准确率', dataIndex: 'accuracy' },
    { title: '版本', dataIndex: 'version' },
    { title: '状态', dataIndex: 'status', render: s => <Badge status={s === 'active' ? 'success' : 'default'} text={s === 'active' ? '启用' : '弃用'} /> },
    {
      title: '操作', render: (_, record) => (
        <Button type="link" icon={<InfoCircleOutlined />} onClick={() => setSelectedAlgo(record)}>详情</Button>
      )
    }
  ];

  const handleSync = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      alert('算法库同步完成！');
    }, 1000);
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="遥感反演碳储量算法库" extra={<Button icon={<SyncOutlined spin={loading} />} onClick={handleSync}>同步更新</Button>}>
        <Table dataSource={algorithms} columns={columns} />
      </Card>

      <Modal open={!!selectedAlgo} title="算法详情" onCancel={() => setSelectedAlgo(null)} footer={null}>
        {selectedAlgo && (
          <Descriptions column={1} bordered>
            <Descriptions.Item label="名称">{selectedAlgo.name}</Descriptions.Item>
            <Descriptions.Item label="作者">{selectedAlgo.author}</Descriptions.Item>
            <Descriptions.Item label="准确率">{selectedAlgo.accuracy}</Descriptions.Item>
            <Descriptions.Item label="适用场景">适用于多源遥感特征融合，对异质区域效果较好。</Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </div>
  );
};

export default AlgorithmLibraryModule;